import { render } from "./CompactMenuItem.vue?vue&type=template&id=07e4f8f2&scoped=true"
import script from "./CompactMenuItem.vue?vue&type=script&lang=js"
export * from "./CompactMenuItem.vue?vue&type=script&lang=js"

import "./CompactMenuItem.vue?vue&type=style&index=0&id=07e4f8f2&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e4f8f2"]])

export default __exports__